export const common = {
  nav: {
    home: 'Beranda',
    about: 'Tentang',
    rooms: 'Kamar',
    gallery: 'Galeri',
    reservation: 'Reservasi',
    access: 'Akses',
    contact: 'Kontak',
    forOwners: 'Untuk Pemilik Properti',
    freeConsultation: 'Konsultasi Gratis',
  },
  hero: {
    title: 'Di Mana Tradisi Bertemu',
    subtitle: 'Kenyamanan Modern',
    description: 'Rasakan pesona autentik rumah tradisional Jepang di Magome, Ota-ku, Tokyo. Perpaduan sempurna antara keindahan bersejarah dan kenyamanan kontemporer.',
    bookNow: 'Pesan Sekarang',
    viewGallery: 'Lihat Galeri',
  },
  about: {
    title: 'Tentang',
    subtitle: 'Perpaduan harmonis antara arsitektur Jepang tradisional dan kenyamanan modern',
    description: 'Rumah Tradisional Magome adalah rumah Jepang yang telah dipugar dengan indah, terletak di kawasan perumahan tenang Magome, Ota-ku, Tokyo. Direnovasi dengan cermat untuk menjaga pesona tradisionalnya sambil menawarkan fasilitas modern, memberikan kesempatan unik untuk merasakan kehidupan Jepang yang autentik.',
    feature1Title: 'Seluruh Rumah',
    feature1Desc: 'Nikmati privasi penuh bersama keluarga dan teman dalam sewa eksklusif ini',
    feature2Title: 'Dapur Lengkap',
    feature2Desc: 'Dapur lengkap untuk menyiapkan makanan favorit Anda',
    feature3Title: 'Hingga 8 Tamu',
    feature3Desc: 'Akomodasi luas yang sempurna untuk kelompok dan keluarga',
    feature4Title: 'Tatami Tradisional',
    feature4Desc: 'Kamar Jepang autentik dengan tikar tatami dan kehangatan kayu',
  },
  rooms: {
    title: 'Kamar',
    subtitle: 'Bersantai di ruang bergaya Jepang tradisional',
    room1: 'Denah Lantai',
    room2: 'Dapur Lengkap',
    room3: 'Tempat Tidur Tambahan',
    capacity: 'Kapasitas Maksimum',
    guests: '8 Tamu',
    amenities: 'Fasilitas',
    amenitiesList: 'Dapur lengkap, Kulkas, Microwave, Peralatan masak, Peralatan makan, Wi-Fi, AC, Pemanas, Mesin cuci, Kamar mandi, Toilet, Handuk, Perlengkapan mandi',
  },
  gallery: {
    title: 'Galeri',
    subtitle: 'Temukan keindahan Rumah Tradisional Magome',
  },
  reservation: {
    title: 'Reservasi',
    subtitle: 'Pesan menginap istimewa Anda',
    name: 'Nama Lengkap',
    email: 'Alamat Email',
    phone: 'Nomor Telepon',
    checkin: 'Check-in',
    checkout: 'Check-out',
    guests: 'Jumlah Tamu',
    message: 'Permintaan Khusus',
    submit: 'Kirim Reservasi',
    submitting: 'Mengirim...',
    success: 'Permintaan reservasi Anda telah diterima. Kami akan menghubungi Anda segera.',
    error: 'Gagal mengirim. Silakan coba lagi.',
    bookingPlatforms: 'Anda juga dapat memesan melalui platform ini',
    bookOnAirbnb: 'Cek ketersediaan & pesan di Airbnb',
    bookOnJalan: 'Cek ketersediaan & pesan di Jalan',
    orDirectBooking: 'atau hubungi kami langsung',
    required: 'Wajib',
    guestsPlaceholder: '― Pilih jumlah tamu ―',
    guestSingular: 'Tamu',
    guestPlural: 'Tamu',
    messagePlaceholder: 'Ada permintaan khusus atau pertanyaan? Silakan tulis. (maks. 500 karakter)',
    confirmNote: '※ Kami akan menghubungi Anda setelah mengkonfirmasi permintaan reservasi.',
  },
  contact: {
    title: 'Kontak',
    subtitle: 'Jangan ragu untuk menghubungi kami dengan pertanyaan atau permintaan',
    name: 'Nama Lengkap',
    email: 'Alamat Email',
    subject: 'Subjek',
    message: 'Pesan',
    submit: 'Kirim',
    submitting: 'Mengirim...',
    success: 'Pesan Anda telah diterima. Kami akan menghubungi Anda segera.',
    error: 'Gagal mengirim. Silakan coba lagi.',
    address: 'Alamat',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Akses',
    accessDetail: '8 menit berjalan kaki dari Stasiun Magome (Toei Asakusa Line)',
    faqBannerTitle: 'Sebelum mengirim, periksa FAQ kami',
    faqBannerDesc: 'Kami telah menjawab banyak pertanyaan umum tentang harga, prosedur, dan manajemen.',
    faqBannerBtn: 'Lihat FAQ',
    accessInfoTitle: 'Informasi Akses',
    sendMessageTitle: 'Kirim Pesan',
    inquiryType: 'Jenis Pertanyaan',
    inquiryTypePlaceholder: 'Pilih jenis pertanyaan',
    inquiryOptions: {
      minpaku: 'Pendaftaran Minpaku / Permohonan Izin',
      ryokan: 'Perolehan Lisensi Ryokan',
      management: 'Manajemen Properti / Operasi',
      pricing: 'Harga / Paket',
      marketing: 'Listing Airbnb / Pemasaran',
      revenue: 'Simulasi Pendapatan',
      other: 'Lainnya',
    },
    messagePlaceholder: 'Jelaskan pertanyaan Anda (maks. 500 karakter)',
    detailLabel: 'Detail Konsultasi',
    detailPlaceholder: 'Jelaskan lokasi properti, kondisi saat ini, dan permintaan Anda (maks. 500 karakter)',
  },
  access: {
    label: 'Akses',
    title: 'Akses & Peta',
    subtitle: 'Terletak di kawasan perumahan tenang Higashi-Magome, Ota-ku, Tokyo',
    addressLabel: 'Alamat',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'Dengan Kereta',
    trainLine1: '2 menit berjalan kaki dari Stasiun Magome (Toei Asakusa Line)',
    trainLine2: '',
    busLabel: 'Dengan Bus',
    busLine1: '2 menit berjalan kaki dari halte bus "Magome Ekimae" (Toei Bus)',
    busLine2: '',
    parkingLabel: 'Parkir',
    parkingLine1: 'Tersedia tempat parkir berbayar di sekitar',
    parkingLine2: 'Hubungi kami jika Anda berencana datang dengan mobil',
    openMap: 'Buka di Google Maps',
  },
  footer: {
    description: 'Sewa rumah tradisional Jepang di Magome, Ota-ku, Tokyo. Rasakan harmoni sempurna antara keindahan Jepang dan kenyamanan modern.',
    quickLinks: 'Tautan Cepat',
    followUs: 'Ikuti Kami',
    rights: 'Hak cipta dilindungi.',
    napTitle: 'Kantor Yokota — Akuntansi & Pajak',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Telp: Silakan hubungi kami',
    napServiceArea: 'Area Layanan: Ota City dan seluruh Tokyo',
    napAccess: 'Toei Asakusa Line — Stasiun Magome',
  },
  stickyButton: {
    title: 'Konsultasi 30 Menit',
    subtitle: 'Gratis',
  },
  ownersBanner: {
    subtitle: 'Untuk pemilik properti yang mempertimbangkan Airbnb di Tokyo',
    linkText: 'Pelajari layanan dukungan untuk pemilik properti →',
  },
  airbnbLead: {
    title: 'Ingin Memulai Airbnb di Tokyo?',
    description: 'Kami menyediakan dukungan menyeluruh — mulai dari pendaftaran minpaku dan perolehan lisensi ryokan hingga manajemen properti penuh. Berbasis di Kota Ota dengan pengalaman operasional nyata.',
    ctaButton: 'Dapatkan Konsultasi Gratis',
    badge1: 'Konsultasi tanpa kewajiban',
    badge2: 'Pengalaman operasional nyata',
    badge3: 'Dukungan penuh dari perizinan hingga manajemen',
  },
  trust: {
    badge: 'Mengapa Memilih Kami',
    title: 'Dipercaya oleh Pemilik Properti Tokyo',
    subtitle: 'Kami menggabungkan pengalaman operasional nyata dengan dukungan komprehensif untuk membantu Anda sukses.',
    point1Title: 'Pengalaman Airbnb Nyata',
    point1Description: 'Kami secara aktif mengoperasikan penginapan tradisional kami sendiri di Kota Ota. Saran kami berdasarkan pengalaman langsung, bukan teori.',
    point2Title: 'Dukungan Perizinan Penuh',
    point2Description: 'Dari pendaftaran minpaku hingga perolehan lisensi ryokan — kami menangani semua dokumen dan komunikasi dengan pihak berwenang.',
    point3Title: 'Optimasi Pendapatan',
    point3Description: 'Strategi penetapan harga berbasis data dari data pasar Tokyo nyata. Rata-rata peningkatan pendapatan 30%+ untuk klien kami.',
    point4Title: 'Dukungan Tamu 24/7',
    point4Description: 'Komunikasi tamu multibahasa sepanjang waktu agar Anda fokus pada penghasilan, bukan pengelolaan.',
    point5Title: 'Laporan Transparan',
    point5Description: 'Laporan pendapatan bulanan dan struktur biaya yang jelas. Tidak ada biaya tersembunyi, tidak ada kejutan.',
    ctaButton: 'Jelajahi Layanan Kami',
  },
  howItWorks: {
    title: 'Cara Kerja',
    subtitle: 'Proses sederhana dan transparan dari konsultasi hingga peluncuran yang sukses',
    step1Number: '01',
    step1Title: 'Konsultasi Gratis',
    step1Desc: 'Bagikan detail dan tujuan properti Anda. Kami memberikan saran jujur tentang perizinan, potensi pendapatan, dan langkah selanjutnya.',
    step2Number: '02',
    step2Title: 'Penilaian Properti',
    step2Desc: 'Kami mengevaluasi kesesuaian properti Anda, mengidentifikasi persyaratan, dan membuat rencana tindakan yang disesuaikan.',
    step3Number: '03',
    step3Title: 'Peluncuran & Dukungan',
    step3Desc: 'Dari pengajuan lisensi hingga manajemen tamu, kami menangani segalanya agar Anda fokus pada penghasilan.',
    ctaButton: 'Pesan Konsultasi Gratis Anda',
    ctaNote: '30 menit • Tanpa kewajiban • Peta jalan yang jelas',
  },
  urgency: {
    title: 'Ingin Memulai Airbnb di Tokyo?',
    description: 'Aturan perizinan kompleks dan kesalahan dapat menunda peluncuran Anda. Dapatkan saran yang jelas dan praktis sebelum mengambil keputusan.',
    ctaButton: 'Pesan Konsultasi Gratis',
    note: 'Konsultasi 30 menit • Tanpa kewajiban • Pengalaman nyata',
  },
  trustRisk: {
    title: 'Konsultasi Tanpa Tekanan',
    description: 'Kami memberikan saran praktis berdasarkan pengalaman nyata. Bahkan jika Anda memutuskan untuk tidak melanjutkan, Anda akan mendapatkan peta jalan yang jelas.',
    badge1Title: 'Tanpa Kewajiban',
    badge1Desc: 'Saran gratis tanpa tekanan',
    badge2Title: 'Pengalaman Nyata',
    badge2Desc: 'Kami mengoperasikan properti kami sendiri',
    badge3Title: 'Peta Jalan Jelas',
    badge3Desc: 'Panduan yang dapat langsung diterapkan',
    whatYouGetTitle: 'Yang Akan Anda Dapatkan dari Konsultasi Kami',
    item1: 'Penilaian jujur tentang potensi properti Anda',
    item2: 'Penjelasan jelas tentang persyaratan perizinan dan jadwal',
    item3: 'Proyeksi pendapatan realistis berdasarkan lokasi Anda',
    item4: 'Peta jalan langkah demi langkah yang dapat Anda ikuti secara mandiri',
    ctaButton: 'Jadwalkan Konsultasi Gratis Anda',
    ctaNote: 'Tersedia Senin–Jumat, 9:00–18:00 JST',
  },
  faq: {
    title: 'Pertanyaan yang Sering Diajukan',
    subtitle: 'Pertanyaan umum tentang memulai dan mengoperasikan bisnis Airbnb dan Minpaku di Tokyo',
    ctaText: 'Punya pertanyaan lain? Kami siap membantu.',
    ctaButton: 'Pesan Konsultasi Gratis',
    q1: 'Bagaimana cara memulai Airbnb di Tokyo?',
    a1: 'Memulai Airbnb di Tokyo memerlukan perizinan yang tepat. Ada dua pilihan utama: pendaftaran Minpaku (penginapan residensial) atau lisensi Ryokan (penginapan sederhana). Minpaku mengizinkan operasi hingga 180 hari per tahun dan memerlukan pendaftaran ke otoritas lokal. Lisensi Ryokan mengizinkan operasi sepanjang tahun tetapi memerlukan pemenuhan standar fasilitas dan peraturan keselamatan kebakaran yang lebih ketat.',
    q2: 'Apa perbedaan antara Minpaku dan lisensi Ryokan?',
    a2: 'Minpaku adalah pendaftaran penginapan residensial yang memungkinkan pemilik properti menyewakan rumah mereka hingga 180 hari per tahun. Persyaratannya lebih sederhana tetapi ada batasan operasional. Ryokan adalah lisensi bisnis penginapan sederhana yang mengizinkan operasi sepanjang tahun tanpa batas hari. Namun, memerlukan pemenuhan standar fasilitas, peralatan keselamatan kebakaran, dan inspeksi rutin yang lebih ketat.',
    q3: 'Apakah orang asing bisa memulai Airbnb di Jepang?',
    a3: 'Ya, orang asing dapat memulai bisnis Airbnb di Jepang, tetapi ada persyaratan penting. Anda harus memiliki status residensi yang tepat yang mengizinkan kegiatan bisnis di Jepang. Kepemilikan properti atau perjanjian sewa yang valid diperlukan, dan Anda harus menunjuk perwakilan manajemen yang tinggal di Jepang dan dapat merespons masalah dalam 30 menit.',
    q4: 'Berapa lama pendaftaran Minpaku di Tokyo?',
    a4: 'Pendaftaran Minpaku di Tokyo biasanya memakan waktu 2–4 bulan dari persiapan awal hingga persetujuan. Jadwalnya meliputi: penilaian dan persiapan properti (2–3 minggu), persiapan dokumen dan inspeksi keselamatan kebakaran (2–4 minggu), pengajuan ke pemerintah daerah (pemrosesan 1–2 minggu), dan persetujuan dan pendaftaran akhir (1–2 minggu).',
    q5: 'Berapa biaya untuk memulai?',
    a5: 'Biaya bervariasi tergantung pada cakupan layanan dan kondisi properti Anda. Kami menawarkan paket yang mencakup dukungan pengajuan, persiapan dokumen, dan penilaian di tempat. Untuk layanan manajemen properti, kami menggunakan struktur biaya berbasis kinerja — persentase dari pendapatan — sehingga Anda dapat memulai dengan biaya awal minimal.',
    q6: 'Apa yang bisa Anda tangani jika saya kesulitan mengelola sendiri?',
    a6: 'Kami dapat menangani segalanya — manajemen reservasi, komunikasi tamu, koordinasi kebersihan, serah terima kunci, penyelesaian masalah, dan laporan pendapatan bulanan. Pemilik properti pada dasarnya dapat menjalankan operasi Airbnb tanpa harus turun tangan.',
    q7: 'Bisakah saya menjalankan Airbnb di apartemen?',
    a7: 'Menjalankan Airbnb di apartemen dimungkinkan selama tidak dilarang oleh aturan manajemen gedung. Anda perlu memeriksa peraturan manajemen terlebih dahulu untuk memastikan tidak ada klausul yang melarang kegiatan penginapan atau sewa jangka pendek.',
    q8: 'Saya khawatir tentang keluhan dari tetangga. Bagaimana Anda menanganinya?',
    a8: 'Kami menetapkan aturan rumah yang jelas untuk tamu (kebisingan, pembuangan sampah, penggunaan area umum, dll.) dan menjelaskannya dengan cermat saat check-in untuk mencegah masalah sebelum terjadi. Jika ada keluhan, kami memiliki sistem respons 24 jam untuk menilai dan menangani situasi dengan cepat.',
    q9: 'Berapa pendapatan yang bisa saya harapkan?',
    a9: 'Pendapatan sangat bervariasi tergantung pada lokasi, ukuran, fasilitas, dan tingkat hunian properti. Di area populer Tokyo, properti 1LDK hingga 2LDK dapat menghasilkan pendapatan bulanan ¥200.000–¥500.000 dalam beberapa kasus. Kami menawarkan simulasi pendapatan gratis berdasarkan data operasional masa lalu kami.',
    q10: 'Apakah boleh hanya konsultasi saja? Apakah saya akan dipaksa menandatangani kontrak?',
    a10: 'Tentu saja — konsultasi saja sangat disambut. Kami tidak pernah memaksa Anda menandatangani kontrak di tempat. Kami berharap Anda meluangkan waktu dan membuat keputusan sesuai kecepatan Anda sendiri.',
  },
  seo: {
    home: {
      title: 'Magome Kominka | Rumah Tradisional Jepang Tokyo & Manajemen Airbnb',
      description: 'Menginap di rumah tradisional Jepang di Magome, Ota-ku, Tokyo — sewa seluruh rumah hingga 8 orang. Manajemen Airbnb profesional dan dukungan lisensi minpaku oleh host aktif.',
      keywords: 'Magome Kominka, Tokyo Airbnb, Ota City minpaku, rumah tradisional Jepang, sewa jangka pendek Tokyo',
    },
    management: {
      title: 'Layanan Manajemen Airbnb Tokyo | Sewa Jangka Pendek Lengkap',
      description: 'Manajemen Airbnb profesional di Tokyo. Komunikasi tamu, penetapan harga dinamis, koordinasi kebersihan, dan laporan bulanan. Manajemen sewa jangka pendek lengkap untuk pemilik di Ota City dan Tokyo.',
      keywords: 'manajemen Airbnb Tokyo, sewa jangka pendek Tokyo, manajemen properti Ota City, layanan tamu Tokyo',
    },
    support: {
      title: 'Dukungan Minpaku & Lisensi Ryokan Tokyo | Peluncuran Bisnis Penginapan',
      description: 'Dukungan ahli untuk pendaftaran minpaku dan permohonan lisensi ryokan di Tokyo. Panduan praktis dari host aktif di Ota City — dari dokumen administrasi hingga peluncuran pendapatan.',
      keywords: 'pendaftaran minpaku Tokyo, lisensi ryokan Tokyo, dukungan Airbnb Tokyo, sewa jangka pendek Ota City',
    },
    forOwners: {
      title: 'Manajemen Airbnb Tokyo & Dukungan Lisensi Minpaku untuk Pemilik Properti',
      description: 'Manajemen Airbnb lengkap dan dukungan lisensi minpaku untuk pemilik properti di Tokyo. Dari perizinan hingga operasi harian dan kebersihan — dukungan penuh. Konsultasi gratis.',
      keywords: 'pemilik Airbnb Tokyo, dukungan lisensi minpaku, manajemen properti Tokyo, Airbnb Ota City',
    },
    pricing: {
      title: 'Harga Manajemen Airbnb Tokyo | Paket Transparan untuk Pemilik Properti',
      description: 'Harga jelas dan transparan untuk manajemen Airbnb dan dukungan minpaku di Tokyo. Paket dukungan peluncuran, setup lengkap, layanan manajemen, dan kebersihan. Tanpa biaya tersembunyi.',
      keywords: 'harga manajemen Airbnb Tokyo, biaya dukungan minpaku, paket sewa jangka pendek Tokyo, biaya manajemen Tokyo',
    },
    minpakuRegistration: {
      title: 'Pendaftaran Minpaku Tokyo | Panduan Langkah demi Langkah Lisensi Ryokan',
      description: 'Panduan lengkap pendaftaran minpaku di Tokyo. Proses permohonan lisensi ryokan, dokumen yang diperlukan, jadwal, dan kesalahan umum — berdasarkan pengalaman operasional nyata di Ota City.',
      keywords: 'pendaftaran minpaku Tokyo, lisensi ryokan Tokyo, dukungan Airbnb Tokyo, sewa jangka pendek Ota City',
    },
    guide: {
      title: 'Panduan Startup Minpaku Tokyo 2026 | Lisensi, Pendapatan & Manajemen',
      description: 'Panduan lengkap memulai bisnis Airbnb di Tokyo. Minpaku vs Ryokan, langkah perizinan, jadwal, kesalahan umum, estimasi pendapatan, dan kapan menggunakan layanan manajemen.',
      keywords: 'panduan minpaku Tokyo, mulai Airbnb Tokyo, lisensi minpaku, lisensi ryokan, sewa jangka pendek Tokyo',
    },
    caseStudy: {
      title: 'Studi Kasus Peluncuran Minpaku Ota City | Kisah Sukses Airbnb Tokyo',
      description: 'Studi kasus nyata: Pemilik properti di Ota City meluncurkan Airbnb dalam 3,5 bulan dengan lisensi Ryokan, mencapai ¥180.000+/bulan dan tingkat hunian 78%. Dukungan minpaku Tokyo dalam praktik.',
      keywords: 'Ota City minpaku, studi kasus Airbnb Tokyo, lisensi ryokan Tokyo, manajemen Airbnb Tokyo',
    },
    adsLanding: {
      title: 'Mulai Bisnis Airbnb Legal di Tokyo | Dukungan Lisensi Minpaku & Ryokan',
      description: 'Dukungan profesional lisensi minpaku dan ryokan di Tokyo. Manajemen Airbnb end-to-end dari host aktif di Ota City. Konsultasi gratis 30 menit. Dukungan peluncuran mulai ¥300.000.',
      keywords: 'Airbnb legal Tokyo, dukungan lisensi minpaku, permohonan ryokan Tokyo, peluncuran Airbnb Ota City',
    },
    airbnbGuide: {
      title: 'Panduan Legal Airbnb Tokyo | Panduan Lengkap Lisensi Minpaku & Ryokan',
      description: 'Panduan lengkap memulai Airbnb secara legal di Tokyo. Pendaftaran minpaku, persyaratan lisensi ryokan, biaya, jadwal, dan proses langkah demi langkah — berdasarkan pengalaman operasional nyata di Ota City.',
      keywords: 'lisensi Airbnb Tokyo, pendaftaran minpaku Tokyo, lisensi ryokan Tokyo, manajemen Airbnb Tokyo, sewa jangka pendek Ota City',
    },
  },
  schema: {
    management: {
      offerDescription: '15%–20% dari pendapatan bulanan',
      service1: 'Penyesuaian harga & penetapan harga dinamis',
      service2: 'Komunikasi tamu (multibahasa)',
      service3: 'Manajemen ulasan',
      service4: 'Koordinasi kebersihan & linen',
      service5: 'Laporan pendapatan bulanan',
      service6: 'Program bantuan pengajuan pajak',
    },
  },
  taxOffice: {
    badge: 'Kantor Akuntansi & Pajak',
    sectionTitle: 'Kantor Yokota — Akuntansi & Pajak',
    sectionSubtitle: 'Ahli dukungan pajak minpaku di Higashi-Magome, Ota City, Tokyo',
    businessName: 'Kantor Yokota — Akuntansi & Pajak',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Alamat',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'Area Layanan',
    serviceArea: 'Ota City dan seluruh Tokyo',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'Akses',
    accessJa: 'Toei Asakusa Line — Stasiun Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Buka di Google Maps',
    supportTitle: 'Dukungan Pajak Minpaku & Airbnb',
    supportItems: [
      'Sistem bantuan pengajuan pajak (bukan perwakilan pajak)',
      'Dukungan pajak minpaku di Ota City',
      'Konsultasi pajak Airbnb Tokyo',
      'Dukungan pajak minpaku Tokyo — konsultasi pertama gratis',
      'Konsultasi pajak Airbnb Tokyo — bantuan pelaporan pendapatan',
    ],
    disclaimer: '※ "Sistem bantuan pengajuan pajak" mengacu pada bantuan persiapan dokumen dan saran. Ini bukan perwakilan pajak.',
    officeImageAlt: 'Kantor Yokota — Kantor akuntansi di Higashi-Magome, Ota City',
    officeImageCaption: 'Kantor Yokota — Higashi-Magome, Ota City, Tokyo',
    officeImageSubCaption: 'Dukungan pajak minpaku Ota City · Konsultasi pajak Airbnb Tokyo',
  },
  managementContact: {
    title: 'Formulir Konsultasi Gratis',
    name: 'Nama Lengkap',
    nameRequired: 'Wajib',
    phone: 'Nomor Telepon',
    email: 'Alamat Email',
    emailRequired: 'Wajib',
    propertyType: 'Tipe Properti',
    propertyTypePlaceholder: 'Silakan pilih',
    propertyTypeOptions: {
      mansion1k: 'Apartemen（Studio–1LDK）',
      mansion2ldk: 'Apartemen（2LDK+）',
      house: 'Rumah Tapak',
      kominka: 'Rumah Tradisional',
      taxConsult: 'Konsultasi Pajak',
      other: 'Lainnya',
    },
    consultContent: 'Detail Konsultasi',
    consultContentRequired: 'Wajib',
    consultContentCounter: '{{count}}/500 karakter',
    consultContentPlaceholder: 'Jelaskan lokasi properti, kondisi saat ini, dan permintaan Anda（maks. 500 karakter）',
    submit: 'Ajukan Konsultasi Gratis',
    submitting: 'Mengirim...',
    success: 'Terima kasih atas pertanyaan Anda. Kami akan menghubungi Anda dalam 2 hari kerja.',
    error: 'Gagal mengirim. Silakan coba lagi.',
    beforeContact: 'Sebelum Menghubungi Kami',
    infoItems: [
      'Konsultasi pertama sepenuhnya gratis',
      'Terutama melayani area Tokyo',
      'Balasan dalam 2 hari kerja',
      'Informasi pribadi Anda dijaga ketat',
    ],
    recommendTitle: 'Kami Sarankan Konsultasi Jika Anda…',
    recommendItems: [
      'Memiliki properti tetapi tidak bisa mengelolanya sendiri',
      'Ingin memulai Minpaku sebagai usaha sampingan',
      'Tidak puas dengan pendapatan saat ini',
      'Sedang mencari layanan kebersihan',
      'Tidak tahu cara menggunakan Airbnb',
    ],
    confirmNote: 'Setelah konfirmasi, staf kami akan menghubungi Anda.',
  },
  privateDriver: {
    badge: 'Layanan Mitra',
    title: 'Pengemudi Pribadi',
    titleEn: 'Private Driver Service',
    description: 'Pengemudi mitra kami menyediakan transportasi profesional — dari transfer bandara hingga tur wisata.',
    descriptionHighlight: 'Pengemudi berbahasa Inggris tersedia.',
    featureTitle: 'Mengapa Memilih Layanan Kami',
    features: [
      { title: 'Pengemudi Berbahasa Inggris', desc: 'Pengemudi profesional berbahasa Inggris untuk tamu internasional.' },
      { title: 'Aman & Terjamin', desc: 'Pengemudi profesional berlisensi penuh menjamin perjalanan yang aman dan nyaman.' },
      { title: 'Tersedia 24/7', desc: 'Penerbangan pagi atau kedatangan larut malam — kami selalu siap dengan pemesanan awal.' },
      { title: 'Bagasi Besar OK', desc: 'Kendaraan besar tersedia untuk keluarga. Beberapa koper bukan masalah.' },
      { title: 'Rute Kustom', desc: 'Rute khusus ke spot retro Showa dan lokasi pemotretan tersedia atas permintaan.' },
    ],
    menuTitle: 'Menu Layanan',
    priceGuide: 'Panduan Harga',
    pricingTitle: 'Panduan Harga',
    pricingNote: 'Semua harga sudah termasuk pajak. Hanya perkiraan — hubungi kami untuk penawaran tepat.',
    discountBadge: 'Diskon Eksklusif',
    discountTitle: 'Khusus Tamu',
    discountOff: 'DISKON 10%',
    discountSuffix: 'Diskon Spesial',
    discountNote: 'Sebutkan masa menginap Anda saat memesan untuk mendapatkan diskon.',
    discountBtn: 'Pesan Sekarang',
    ctaBadge: 'Eksklusif untuk Tamu KOMINKA',
    ctaTitle: 'Harga Spesial untuk Tamu',
    ctaDesc: 'Tamu KOMINKA menikmati diskon eksklusif untuk layanan pengemudi pribadi kami.',
    ctaBtn: 'Pesan Pengemudi',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'Transfer Bandara', subtitle: '空港送迎', desc: 'Penjemputan & pengantaran bandara Haneda/Narita. Layanan meet & greet tersedia.', price: 'Mulai ¥8.000' },
      { title: 'Tur Kota Tokyo', subtitle: '東京観光ドライブ', desc: 'Jelajahi kawasan era Showa, kuil, dan permata tersembunyi bersama pengemudi lokal.', price: 'Mulai ¥15.000/3j' },
      { title: 'Dukungan Tinggal Lama', subtitle: '長期滞在サポート', desc: 'Layanan pengemudi mingguan atau bulanan untuk belanja dan perjalanan sehari.', price: 'Mulai ¥40.000/minggu' },
      { title: 'Perjalanan Lokasi Foto', subtitle: '撮影ロケ送迎', desc: 'Transportasi ke spot era Showa ikonik dan lokasi film.', price: 'Mulai ¥12.000/2j' },
    ],
    pricing: [
      { title: 'Transfer Bandara', subtitle: 'Airport Transfer', rows: [{ label: 'Bandara Haneda ⇔ Magome (satu arah)', price: '¥8.000+' }, { label: 'Bandara Narita ⇔ Magome (satu arah)', price: '¥14.000+' }, { label: 'Biaya tambahan malam (22:00–6:00)', price: '+¥2.000' }, { label: 'Bagasi besar (3+ koper)', price: '+¥1.000' }], note: '* Harga sama untuk hingga 4 penumpang' },
      { title: 'Tur Kota Tokyo', subtitle: 'Tokyo City Tour', rows: [{ label: 'Kursus 3 jam', price: '¥15.000+' }, { label: 'Kursus 5 jam', price: '¥22.000+' }, { label: 'Seharian (8 jam)', price: '¥35.000+' }, { label: 'Rute khusus Showa Retro', price: '+¥3.000' }], note: '* Biaya pemandu & parkir termasuk' },
      { title: 'Perjalanan Lokasi Foto', subtitle: 'Photo Location Drive', rows: [{ label: 'Kursus 2 jam', price: '¥12.000+' }, { label: 'Kursus 4 jam', price: '¥20.000+' }, { label: 'Opsi pemandu lokasi', price: '+¥2.000' }, { label: 'Penanganan peralatan/bagasi besar', price: '+¥1.500' }], note: '* Konsultasi rute tersedia sebelumnya' },
      { title: 'Dukungan Tinggal Lama', subtitle: 'Long Stay Support', rows: [{ label: 'Paket sekali seminggu (4x/bulan)', price: '¥40.000+' }, { label: 'Paket dua kali seminggu (8x/bulan)', price: '¥72.000+' }, { label: 'Penggunaan tunggal (3 jam)', price: '¥12.000+' }, { label: 'Belanja/transfer rumah sakit', price: '¥6.000+/perjalanan' }], note: '* Diskon 10% dengan pembayaran bulanan' },
    ],
  },
};

export default common;
